import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"
import { SiteFooter } from "@components/site/SiteFooter"

export const meta: ViewMeta = {
  templateName: "Collections",
}

export default defineView("template-collections", (props) => {
  return (
    <PageProvider {...props.page?.page}>
      <ContentBlocks blocks={props.page?.contentBlocks} />
      <SiteFooter />
    </PageProvider>
  )
})
